import React from 'react';
import { Phone, AlertCircle, CheckCircle, Wrench } from 'lucide-react';
export function BrakeRepair() {
  return <div className="min-h-screen bg-gray-50" data-id="element-950">
      {/* Hero Section */}
      <div className="bg-gradient-to-r from-[#B1050B] to-[#8A0408] text-white py-16" data-id="element-951">
        <div className="container mx-auto px-4" data-id="element-952">
          <h1 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-953">Brake Repair</h1>
          <p className="text-xl text-gray-100" data-id="element-954">
            <strong data-id="element-955">
              Serving Farmington Hills, Farmington, Novi, Livonia, Northville
              and discerning motorists from around the metropolitan Detroit area
              Since 1958
            </strong>
          </p>
        </div>
      </div>

      {/* Main Content */}
      <div className="container mx-auto px-4 py-12" data-id="element-956">
        <div className="max-w-4xl mx-auto" data-id="element-957">
          {/* Introduction */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-958">
            <div className="flex items-center justify-center mb-6" data-id="element-959">
              <img src="//drwzpk38qkpfb.cloudfront.net/core/getthumb?file=uploaded%2Fimages%2Fauto%20truck%20suppliers%2FNew%20Folder%2Fstop.bmp&site=1986&w=223&h=236&user=1617&opt=w3" alt="Stop sign" className="max-w-[223px] h-auto" data-id="element-960" />
            </div>

            <h2 className="text-3xl font-bold text-gray-900 mb-6 text-center" data-id="element-961">
              Brakes are the most important safety device on your car
            </h2>

            <p className="text-lg text-gray-700 text-center" data-id="element-962">
              Inspecting your brakes twice a year for wear and damage can
              protect you and your passengers while saving you money by catching
              any damage before it becomes too costly.
            </p>
          </div>

          {/* Brake Disc Rotor Inspection */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-963">
            <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-964">
              Brake Inspection: Disc Rotor First
            </h2>

            <p className="text-gray-700 mb-6" data-id="element-965">
              The surface of the rotor should be shiny from the inside to the
              outer edge, and fairly uniform. Don't worry if you can see slight
              lines in it, this is normal wear. However, if there are any rough
              spots or pronounced grooves in the disc, you should replace your
              brake discs. Brake discs should always be replaced in pairs so
              that your car's driveability and safety are not compromised.
            </p>

            <div className="grid md:grid-cols-2 gap-6 mb-6" data-id="element-966">
              <div className="bg-red-50 border-2 border-red-300 rounded-lg p-6" data-id="element-967">
                <h3 className="text-xl font-bold text-red-800 mb-3 flex items-center" data-id="element-968">
                  <AlertCircle className="mr-2" size={24} data-id="element-969" />
                  Bad Rotor - Needs Repair
                </h3>
                <img src="//drwzpk38qkpfb.cloudfront.net/core/getthumb?file=uploaded%2Fimages%2Fauto%20truck%20suppliers%2FNew%20Folder%2Freal-bad-rotor.jpg&site=1986&w=342&h=257&user=1617&opt=w3" alt="Bad rotor - needs repair" className="w-full h-[200px] object-contain rounded-lg mb-3" data-id="element-970" />
                <p className="text-gray-700" data-id="element-971">
                  Rough spots, pronounced grooves, or uneven wear indicate the
                  rotor needs replacement or resurfacing.
                </p>
              </div>

              <div className="bg-green-50 border-2 border-green-300 rounded-lg p-6" data-id="element-972">
                <h3 className="text-xl font-bold text-green-800 mb-3 flex items-center" data-id="element-973">
                  <CheckCircle className="mr-2" size={24} data-id="element-974" />
                  Good Rotor After Refacing
                </h3>
                <img src="//drwzpk38qkpfb.cloudfront.net/core/getthumb?file=uploaded%2Fimages%2Fauto%20truck%20suppliers%2FNew%20Folder%2Funtitled.bmp&site=1986&w=334&h=271&user=1617&opt=w3" alt="Good rotor after refacing" className="w-full h-[200px] object-contain rounded-lg mb-3" data-id="element-975" />
                <p className="text-gray-700" data-id="element-976">
                  Smooth, shiny surface with uniform appearance from inner to
                  outer edge.
                </p>
              </div>
            </div>
          </div>

          {/* Brake Pads Inspection */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-977">
            <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-978">
              Brake Pad Inspection
            </h2>

            <p className="text-gray-700 mb-6" data-id="element-979">
              <strong data-id="element-980">Now take a look at the pads.</strong> You'll have to peek
              up to see them, but if you follow the surface of the disc to the
              top, you'll see the outside pad touching the disc. If there is
              1/8" or less remaining on the pad, it's time for new ones. That's
              about the height of three pennies stacked.
            </p>

            <div className="grid md:grid-cols-2 gap-6 mb-6" data-id="element-981">
              <img src="//drwzpk38qkpfb.cloudfront.net/core/getthumb?file=uploaded%2Fimages%2Fauto%20truck%20suppliers%2FNew%20Folder%2FIMG_1917.JPG&site=1986&w=256&h=318&user=1617&opt=w3" alt="Brake pad measurement example" className="w-full h-[250px] object-contain rounded-lg mx-auto" data-id="element-982" />
              <img src="//drwzpk38qkpfb.cloudfront.net/core/getthumb?file=uploaded%2Fimages%2Fauto%20truck%20suppliers%2FNew%20Folder%2FAudi-S6-worn-brake-pads.jpg&site=1986&w=310&h=324&user=1617&opt=w3" alt="Worn brake pads" className="w-full h-[250px] object-contain rounded-lg mx-auto" data-id="element-983" />
            </div>

            <div className="bg-yellow-50 border-l-4 border-yellow-400 p-6" data-id="element-984">
              <div className="flex items-start" data-id="element-985">
                <AlertCircle className="text-yellow-600 mr-3 flex-shrink-0 mt-1" size={24} data-id="element-986" />
                <div data-id="element-987">
                  <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-988">
                    Replacement Threshold
                  </h3>
                  <p className="text-gray-700" data-id="element-989">
                    When brake pad material is 1/8" or less (about the height of
                    three pennies stacked), it's time for replacement. Don't
                    wait until you hear grinding noises - that means
                    metal-on-metal contact and rotor damage.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Brake Lines Inspection */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-990">
            <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-991">
              Brake Line Inspection
            </h2>

            <div className="space-y-6" data-id="element-992">
              <div className="border-l-4 border-[#B1050B] pl-6" data-id="element-993">
                <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-994">
                  Flexible Brake Lines
                </h3>
                <p className="text-gray-700 mb-4" data-id="element-995">
                  Finally, take a look at your brake lines. Rubber coated lines
                  should be soft and supple, not cracked and rigid. If you see
                  cracks in flexible brake lines they will need to be replaced.
                </p>
                <div className="grid md:grid-cols-2 gap-4" data-id="element-996">
                  <img src="//drwzpk38qkpfb.cloudfront.net/core/getthumb?file=uploaded%2Fimages%2Fauto%20truck%20suppliers%2FNew%20Folder%2FYJ_BR007.jpg&site=1986&w=323&h=341&user=1617&opt=w3" alt="Brake line example 1" className="w-full h-[280px] object-contain rounded-lg" data-id="element-997" />
                  <img src="//drwzpk38qkpfb.cloudfront.net/core/getthumb?file=uploaded%2Fimages%2Fauto%20truck%20suppliers%2FNew%20Folder%2Fetuvanha1.jpg&site=1986&w=252&h=354&user=1617&opt=w3" alt="Brake line example 2" className="w-full h-[280px] object-contain rounded-lg" data-id="element-998" />
                </div>
              </div>

              <div className="border-l-4 border-[#B1050B] pl-6" data-id="element-999">
                <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-1000">
                  Hard Metal Lines
                </h3>
                <p className="text-gray-700 mb-4" data-id="element-1001">
                  Also be sure to inspect the hard, metal lines. These can
                  become corroded, especially in snowy regions where chemicals
                  are used on the roads.
                </p>
                <div className="grid md:grid-cols-2 gap-4" data-id="element-1002">
                  <img src="//drwzpk38qkpfb.cloudfront.net/core/getthumb?file=uploaded%2Fimages%2Fauto%20truck%20suppliers%2FNew%20Folder%2Frusty_brakeline.jpg&site=1986&w=263&h=300&user=1617&opt=w3" alt="Rusty brake line" className="w-full h-[250px] object-contain rounded-lg" data-id="element-1003" />
                  <img src="//drwzpk38qkpfb.cloudfront.net/core/getthumb?file=uploaded%2Fimages%2Fauto%20truck%20suppliers%2FNew%20Folder%2FDSCN1631.jpg&site=1986&w=270&h=311&user=1617&opt=w3" alt="Corroded metal brake line" className="w-full h-[250px] object-contain rounded-lg" data-id="element-1004" />
                </div>
              </div>
            </div>

            <div className="bg-red-50 border-l-4 border-red-500 p-6 mt-6" data-id="element-1005">
              <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-1006">
                Critical Safety Issue
              </h3>
              <p className="text-gray-700" data-id="element-1007">
                Corroded or cracked brake lines are extremely dangerous. Brake
                line failure can result in complete loss of braking ability. If
                you notice any corrosion, cracks, or damage to brake lines, have
                them replaced immediately.
              </p>
            </div>
          </div>

          {/* Brake Caliper */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-1008">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center" data-id="element-1009">
              <Wrench className="mr-3 text-[#B1050B]" size={28} data-id="element-1010" />
              Brake Caliper
            </h2>

            <p className="text-gray-700 mb-6" data-id="element-1011">
              Brake caliper – one of the major components of your vehicle's
              brake system. The brake caliper is a U-shaped piece of equipment
              that works just like a tiny hydraulic clamp, designed to hold the
              brake rotor to bring your car to a stop. The brake caliper comes
              with a piston or pistons that can be found on one or both sides of
              it.
            </p>

            <div className="flex justify-center mb-6" data-id="element-1012">
              <img src="//drwzpk38qkpfb.cloudfront.net/core/getthumb?file=uploaded%2Fimages%2Fauto%20truck%20suppliers%2FNew%20Folder%2Fcaliperrebuild002.jpg&site=1986&w=284&h=246&user=1617&opt=w3" alt="Brake caliper" className="max-w-[284px] h-auto rounded-lg" data-id="element-1013" />
            </div>

            <div className="bg-blue-50 rounded-lg p-6" data-id="element-1014">
              <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-1015">
                Common Brake Caliper Issues:
              </h3>
              <ul className="space-y-2 text-gray-700" data-id="element-1016">
                <li className="flex items-start" data-id="element-1017">
                  <CheckCircle className="text-blue-600 mr-2 flex-shrink-0 mt-1" size={16} data-id="element-1018" />
                  <span data-id="element-1019">Seized or sticking pistons</span>
                </li>
                <li className="flex items-start" data-id="element-1020">
                  <CheckCircle className="text-blue-600 mr-2 flex-shrink-0 mt-1" size={16} data-id="element-1021" />
                  <span data-id="element-1022">Leaking brake fluid</span>
                </li>
                <li className="flex items-start" data-id="element-1023">
                  <CheckCircle className="text-blue-600 mr-2 flex-shrink-0 mt-1" size={16} data-id="element-1024" />
                  <span data-id="element-1025">Worn or damaged caliper slides</span>
                </li>
                <li className="flex items-start" data-id="element-1026">
                  <CheckCircle className="text-blue-600 mr-2 flex-shrink-0 mt-1" size={16} data-id="element-1027" />
                  <span data-id="element-1028">Corrosion and rust buildup</span>
                </li>
              </ul>
            </div>
          </div>

          {/* Service Areas */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-1029">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 text-center" data-id="element-1030">
              Brake Repair Service Areas
            </h2>
            <div className="flex flex-wrap justify-center gap-4" data-id="element-1031">
              <span className="bg-gray-100 px-6 py-3 rounded-lg text-gray-800 font-semibold" data-id="element-1032">
                Farmington Hills Brake Repair
              </span>
              <span className="bg-gray-100 px-6 py-3 rounded-lg text-gray-800 font-semibold" data-id="element-1033">
                Novi Brake Repair
              </span>
              <span className="bg-gray-100 px-6 py-3 rounded-lg text-gray-800 font-semibold" data-id="element-1034">
                Northville Brake Repair
              </span>
            </div>
          </div>

          {/* CTA Section */}
          <div className="bg-gradient-to-r from-gray-900 to-gray-800 text-white rounded-lg shadow-xl p-8 text-center" data-id="element-1035">
            <h2 className="text-3xl font-bold mb-4" data-id="element-1036">Need Brake Service?</h2>
            <p className="text-xl mb-6 italic" data-id="element-1037">Give us A call</p>
            <a href="tel:2484788382" className="inline-flex items-center bg-[#B1050B] hover:bg-[#8A0408] text-white px-8 py-4 rounded-lg font-bold text-lg transition-colors shadow-lg" data-id="element-1038">
              <Phone className="mr-3" size={24} data-id="element-1039" />
              Call (248) 478-8382
            </a>
            <p className="mt-4 text-gray-300" data-id="element-1040">
              24175 Industrial Park Dr., Farmington Hills, MI 48335
            </p>
          </div>
        </div>
      </div>
    </div>;
}